export default {"src":"/_next/static/media/arrow-down-red.38161092.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};